import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/layout/Navbar";
import BannedBanner from "./components/BannedBanner";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import PlanTrip from "./pages/PlanTrip";
import Itinerary from "./pages/Itinerary";
import ProtectedRoute from "./components/ProtectedRoute";
import { useAuth } from "./contexts/AuthContext";
import WriteReview from "./pages/WriteReview";
import NotFound from "./pages/NotFound";

import CommunityHome from "./pages/community/Home";
import Feed from "./pages/community/Feed";
import PostDetail from "./pages/community/PostDetail";
import Search from "./pages/community/Search";
import MySaved from "./pages/community/MySaved";
import MyLiked from "./pages/community/MyLiked";
import PublicProfile from "./pages/community/PublicProfile";
import Notifications from "./pages/community/Notifications";
import NotificationSettings from "./pages/community/NotificationSettings";
import AccountProfile from "./pages/AccountProfile";
import NewLandingPage from "./pages/NewLandingPage";
import CreditRules from "./pages/admin/CreditRules";

function VisaRedirect() {
  useEffect(() => {
    window.location.replace("https://roammyway.visa2fly.com");
  }, []);
  return null;
}

function LandingOrDashboard() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-10 h-10 border-4 border-teal-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Home />;
}

function App() {
  const location = useLocation();
  const hideNavbar =
    location.pathname === "/plan" ||
    location.pathname.startsWith("/itinerary");

  return (
    <div className="min-h-screen">
      {!hideNavbar && <Navbar />}
      <BannedBanner />
      <Routes>
       {/* <Route path="/" element={<LandingOrDashboard />} /> */}
       <Route path="/" element={<NewLandingPage />} />
        <Route path="/romaya" element={<Home />} />
        <Route path="/newlandingpage" element={<NewLandingPage />} />
        <Route path="/community" element={<CommunityHome />} />
        <Route path="/community/feed" element={<Feed />} />
        <Route path="/community/search" element={<Search />} />
        <Route path="/community/saved" element={<ProtectedRoute><MySaved /></ProtectedRoute>} />
        <Route path="/community/liked" element={<ProtectedRoute><MyLiked /></ProtectedRoute>} />
        <Route path="/community/:slug" element={<PostDetail />} />
        <Route path="/u/:handle" element={<PublicProfile />} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/settings/notifications" element={<ProtectedRoute><NotificationSettings /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><AccountProfile /></ProtectedRoute>} />
        <Route path="/packages" element={<Home />} />
        <Route path="/privacy" element={<Home />} />
        <Route path="/terms" element={<Home />} />
        <Route path="/contact" element={<Home />} />
        <Route path="/visa" element={<VisaRedirect />} />

        <Route
          path="/auth/signin"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/plan"
          element={
            <ProtectedRoute>
              <PlanTrip />
            </ProtectedRoute>
          }
        />
        <Route
          path="/itinerary"
          element={
            <ProtectedRoute>
              <Itinerary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/itinerary/:id"
          element={
            <ProtectedRoute>
              <Itinerary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reviews/:tripId/write"
          element={
            <ProtectedRoute>
              <WriteReview />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/credit-rules"
          element={
            <ProtectedRoute superAdminOnly>
              <CreditRules />
            </ProtectedRoute>
          }
        />

        {/* /credits was merged into Account → Wallet, which already holds the
            balance, the ledger and the FAQ. The URL is kept as a redirect on
            purpose: the "You earned your first RoamPoints" email links here, and
            those messages are already in people's inboxes. Do not delete it. */}
        <Route path="/credits" element={<Navigate to="/account?tab=wallet" replace />} />

        {/* Catch-all. Without this, any unmatched address rendered a blank page. */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
